export const CACHE_PREFIX = 'gdx_';

export function setSessionCache(key: string, value: string) {
  sessionStorage.setItem(CACHE_PREFIX + key, value);
}

export function getSessionCache(key: string): string | null {
  return sessionStorage.getItem(CACHE_PREFIX + key);
}
